module.exports = __webpack_public_path__ + "img/sdg1.14956cc0.svg";